import type { CatalogRecord } from '../types/registry';

const INTERNAL_TYPE_IDS = new Set(['PROTO', 'CUSTOM']);

function slugify(value: string): string {
  return (
    value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^-|-$/g, '') || 'type'
  );
}

/** Client-side preview of batch_id brand rules (API remains authoritative). */
export function previewBatchId(
  batchDate: string,
  typeIds: string[],
  catalog: CatalogRecord[],
  existingBatchIds: string[] = [],
): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(batchDate) || typeIds.length === 0) return null;
  const byId = new Map(catalog.map((row) => [row.type_id, row]));
  const hasProto = typeIds.includes('PROTO');
  const hasCustom = typeIds.includes('CUSTOM');
  const productIds = typeIds.filter((id) => !INTERNAL_TYPE_IDS.has(id));
  let base =
    productIds.length === 1
      ? slugify(byId.get(productIds[0])?.type_name || productIds[0])
      : 'sensecore';
  if (hasProto) base = `${base}-pro`;
  if (hasCustom) base = `${base}-cus`;
  const prefix = `${batchDate.replace(/-/g, '')}-${base}-`;
  let maxN = 0;
  for (const id of existingBatchIds) {
    if (!id.startsWith(prefix)) continue;
    const suffix = id.slice(prefix.length);
    if (/^\d+$/.test(suffix)) maxN = Math.max(maxN, Number(suffix));
  }
  return `${prefix}${String(maxN + 1).padStart(2, '0')}`;
}
